import { render, staticRenderFns } from "./WorkerEarnings.vue?vue&type=template&id=1bf6ef1a&"
import script from "./WorkerEarnings.vue?vue&type=script&lang=js&"
export * from "./WorkerEarnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports